<template>
  <li>
    <div
      ref="hexagon-container"
      class="hexagon"
      @click="onClick"
    >
      <div class="hexagon-title px-2 tracking-wider leading-normal">
        <p
          class="text-xxs lg:text-xs uppercase font-bold"
          :class="textColor"
        >{{ feature.text }}</p>
        <p
          v-if="feature.description"
          class="text-xxs font-normal"
          :class="textColor"
        >{{feature.description}}</p>
      </div>
    </div>
  </li>
</template>

<script>
import { gsap } from "gsap";

export default {
  name: "HexagonGridElement",
  props: ["feature", "isSelected"],
  computed: {
    target: function () {
      return this.$refs["hexagon-container"];
    },
    textColor: function () {
      return this.isSelected ? "text-white" : "";
    },
  },
  methods: {
    onClick() {
      this.$emit("onClick", this.feature.key);
    },
  },
  watch: {
    isSelected(newValue) {
      const color = newValue ? "#a3bffa" : "#efefef";
      gsap.set(this.target, { backgroundColor: color, ease: "slow" });
    },
  },
};
</script>

<style scoped>
</style>
